/**
 * @description Примесь метрики.
 * @type {any}
 */
export default {
  data() {
    return {
      /**
       * @description Цели которые были достигнуты
       * @type Array<String>
       */
      goalsReached: [],
    };
  },
  methods: {
    /**
     * @description Достигнуть цели, если ещё не достигнута
     * @param goal
     */
    reachGoalIfNotReach(goal) {
      const isReached = this.goalsReached.includes(goal);
      if (!isReached) {
        this.$goal(goal);
        this.goalsReached.push(goal);
      }
    },
  },
};
